/* eslint-disable no-underscore-dangle, react-hooks/exhaustive-deps */
import { useEffect } from 'react'

function useReactContextDevTool({ id, displayName, values }) {
  useEffect(() => {
    if (window._REACT_CONTEXT_DEVTOOL) {
      window._REACT_CONTEXT_DEVTOOL({ id, displayName, values });
    }
  }, [values])
}

export default useReactContextDevTool
